import {observer} from "mobx-react";
import styled from "styled-components";
import {useEffect, useRef} from "react";
import {SIZES} from "@/components/constants";
import {useMediaQuery} from "react-responsive";

const CareerSlidWrap = observer(({ list, type = "default" }) => {
    const trackRef = useRef(null);
    const direction = type === "reverse" ? 1 : -1;
    const speed = 1;
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });

    useEffect(() => {
        const track = trackRef.current;
        if (!track) return;
        let pos = 0;
        let animationId;
        const step = () => {
            pos += direction * speed;
            const trackWidth = track.scrollWidth / 3;
            if (pos < -trackWidth) {
                pos += trackWidth;
            } else if (pos > 0) {
                pos -= trackWidth;
            }
            track.style.transform = `translate3d(${pos}px, 0, 0)`;
            animationId = requestAnimationFrame(step);
        };
        animationId = requestAnimationFrame(step);
        return () => {
            if (animationId) cancelAnimationFrame(animationId);
        };
    }, [type, speed, isTablet]);


    return (
        <Slider>
            <Track ref={trackRef}>
                {[...list, ...list, ...list].map((item, idx) => (
                    <div key={idx} className="career-slide-inner">
                        <div className="image-wrap">
                            <img src={item.imageItem} alt={`slide-${idx}`} />
                        </div>
                    </div>
                ))}
            </Track>
        </Slider>
    );
});


const Slider = styled.div`
    overflow: hidden;
    width: 100%;
    margin-top: 16px;
    &:first-child {
        margin: 0;
    }
    @media (max-width: ${SIZES.TABLET}) {
        margin-top: 16px;
    }
`;
const Track = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    will-change: transform;
    .career-slide-inner {
        width: 250px;
        height: 52px;
        padding: 0 80px;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #E6E6E6;
        border-radius: 10px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
    }
    @media (max-width: ${SIZES.TABLET}) {
        gap: 16px;
        .career-slide-inner {
            width: 148px;
            height: 40px;
            padding: 6px 40px;
            border-radius: 20px;
        }
    }
`;

export default CareerSlidWrap;
